"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var abstract_destruction_subject_1 = require("../../../../utils/abstract-destruction-subject");
var operators_1 = require("rxjs/operators");
require("./form-view.component.scss");
var FormViewComponent = /** @class */ (function (_super) {
    __extends(FormViewComponent, _super);
    function FormViewComponent(activatedRoute, router) {
        var _this = _super.call(this) || this;
        _this.activatedRoute = activatedRoute;
        _this.router = router;
        _this.isReady = true;
        _this.newFormMode = false;
        _this.cols = ['ProjectID', 'Code', 'StartDate', 'Name'];
        return _this;
    }
    FormViewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activatedRoute.params
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (params) {
            _this.formId = params['formId'];
        }, console.error);
    };
    FormViewComponent.prototype.toNewForm = function () {
        this.router.navigate(['/dynamic-de/Activity/demo-form/' + 2517]);
        this.newFormMode = true;
    };
    FormViewComponent.prototype.toPortfolio = function () {
        this.newFormMode = false;
    };
    FormViewComponent.prototype.goToDesigner = function () {
        this.router.navigate(['/forms/' + 2517 + '/form-edit']);
    };
    FormViewComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'form-view',
            template: require('./form-view.component.html'),
            encapsulation: core_1.ViewEncapsulation.None,
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute,
            router_1.Router])
    ], FormViewComponent);
    return FormViewComponent;
}(abstract_destruction_subject_1.AbstractDestructionSubject));
exports.FormViewComponent = FormViewComponent;
//# sourceMappingURL=form-view.component.js.map